import { gql } from '@grandvisionhq/graphql';

const shoppinglistPricesFragment = gql`
  fragment ShoppinglistPricesFragment on ProductPrices {
    discountedPrice {
      discountInformation {
        value
      }
      price {
        amount
        currencyCode
      }
    }
    originalPrice {
      amount
      currencyCode
    }
  }
`;
const shoppinglistMediaFragment = gql`
  fragment ShoppinglistMediaFragment on Media {
    images {
      url
    }
  }
`;
const shoppinglistVariantFragment = gql`
  fragment ShoppinglistVariantFragment on Variant {
    ... on AccessoriesVariant {
      variantTypeDetails {
        color
        channelAvailability
      }
    }
    ... on ContactLensVariant {
      gan
      variantTypeDetails {
        lensType
        packageQuantity
        channelAvailability
      }
    }
    ... on FrameVariant {
      variantTypeDetails {
        frameFeatures {
          color
          size {
            size
          }
        }
        channelAvailability
      }
    }
    ... on ReadyReaderVariant {
      variantTypeDetails {
        nullableFrameFeatures: frameFeatures {
          color
          size {
            size
          }
        }
        channelAvailability
      }
    }
    ... on SolutionVariant {
      gan
    }
    ... on SunglassesVariant {
      variantTypeDetails {
        lensFeatures {
          lensColor
        }
        nullableFrameFeatures: frameFeatures {
          color
          size {
            size
          }
        }
        channelAvailability
      }
    }
  }
`;
const shoppinglistVariantDetailsFragment = gql`
  fragment ShoppinglistVariantDetailsFragment on Variant {
    isAllowBackOrder
    isExcludedFromCheckout
    sku
    ...ShoppinglistVariantFragment
    inventory {
      stockIndicator
      items {
        allowBackInStockNotification
      }
      totalQuantity
    }
    prices {
      ...ShoppinglistPricesFragment
    }
    media {
      ...ShoppinglistMediaFragment
    }
  }
  ${shoppinglistVariantFragment}
  ${shoppinglistMediaFragment}
  ${shoppinglistPricesFragment}
`;
const shoppinglistVariantOverviewFragment = gql`
  fragment ShoppinglistVariantOverviewFragment on Shoppinglist {
    id
    items {
      variant {
        ...ShoppinglistVariantDetailsFragment
      }
    }
  }
  ${shoppinglistVariantDetailsFragment}
`;
const shoppinglistProductOverviewFragment = gql`
  fragment ShoppinglistProductOverviewFragment on Shoppinglist {
    id
    items {
      name
      quantity
      sku
      product {
        brand
        ... on ContactLensProduct {
          id
          productTypeDetails {
            replacementFrequencyAllLocales {
              value
              locale
            }
          }
        }
        slug
      }
    }
  }
`;
const ShoppinglistBasicFragment = gql`
  fragment ShoppinglistBasicFragment on Shoppinglist {
    id
    items {
      sku
      product {
        brand
        ... on ContactLensProduct {
          id
        }
        slug
      }
    }
  }
`;

export { ShoppinglistBasicFragment, shoppinglistProductOverviewFragment, shoppinglistVariantDetailsFragment, shoppinglistVariantFragment, shoppinglistVariantOverviewFragment };
//# sourceMappingURL=shopping-list.js.map
